<script lang="ts">
  import T from "../texts";

  export let s;
  export let agentName;
  export let language;
  export let isOnline;
  export let emailSubmitted: boolean;
  export let submitEmail;
  export let email: string;
</script>

<div>
  <div>
    <div class={s.agentName}>
      {agentName}
    </div>
  </div>
  <div class={s.chatBubbleAgent} style="margin-left: 0 !important;">
    {#if isOnline}
      {T(
        language,
        "Before we continue, what's your email? I can use it to pull up any orders or follow up with you via email in case we get disconnected.",
        [],
      )}
    {:else}
      {T(
        language,
        "We're currently offline. What's your email? Please leave a message here and we'll follow up via email!",
        [],
      )}
    {/if}
  </div>
  {#if emailSubmitted}
    <div class={s.chatEmailForm}>
      {T(language, "Thank you :)", [])}
    </div>
  {:else}
    <form class={s.chatEmailForm} on:submit={submitEmail}>
      <input type="email" bind:value={email} placeholder="foo@bar.com" />
      <input type="submit" class={s.chatEmail} value={T(language, "Submit", [])} />
    </form>
  {/if}
</div>
